import React from 'react';
import styled from 'styled-components';
import Forbes from '../../assets/images/forbes.svg';
import Rbk from '../../assets/images/rbk.svg';
import BB from '../../assets/images/bb.svg';

const About = () => {
  return (
    <AboutContainer>
      <AboutBlock>
        <AboutImage src={Forbes} alt="forbes" />
        <AboutInfo>
          <AboutTitle>Заголовок</AboutTitle>
          <AboutSubTitle>Текст</AboutSubTitle>
        </AboutInfo>
      </AboutBlock>
      <AboutBlock>
        <AboutImage src={Rbk} alt="rbk" />
        <AboutInfo>
          <AboutTitle>Заголовок</AboutTitle>
          <AboutSubTitle>Текст</AboutSubTitle>
        </AboutInfo>
      </AboutBlock>
      <AboutBlock>
        <AboutImage src={BB} alt="bb" />
        <AboutInfo>
          <AboutTitle>Заголовок</AboutTitle>
          <AboutSubTitle>Текст</AboutSubTitle>
        </AboutInfo>
      </AboutBlock>
    </AboutContainer>
  );
};

const AboutContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 3.6rem;
  margin-bottom: -48px;
  @media (max-width: 1135px) {
    margin-bottom: -90px;
  }
  @media (max-width: 599px) {
    margin-bottom: -121px;
  }
`;

const AboutBlock = styled.div`
  display: flex;
  margin-bottom: 2rem;
`;

const AboutImage = styled.img``;

const AboutInfo = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 1.4rem;
  justify-content: space-between;
`;

const AboutTitle = styled.h3`
  font-weight: 700;
  font-size: 24px;
`;

const AboutSubTitle = styled.h3`
  font-weight: 400;
  font-size: 20px;
`;

export default About;
